import { ColumnsType } from 'antd/es/table';
import { Edit2 } from 'iconsax-react';
import SectionDesc from '../../../components/atoms/SectionDesc';
import CustomTable from '../../../components/atoms/CustomTable';
import { useTranslation } from 'react-i18next';
import { useGetAllVatsQuery } from '../../../store/services/commission';
import dayjs from 'dayjs';

export interface VatRecord {
  id: string;
  profileType: string;
  code: string;
  name: string;
  vatPercentage: number;
  editDate: string;
  editBy: null;
}

interface VatsSectionProps {
  onEdit: (record: VatRecord) => void;
}

export default function VatsSection({ onEdit }: VatsSectionProps) {
  const { t } = useTranslation();

  const { data: vatsResponse, isLoading } = useGetAllVatsQuery(undefined);

  const vatsData: VatRecord[] = vatsResponse?.payload || [];

  const vatColumns: ColumnsType<VatRecord> = [
    {
      title: t('home.service-type'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('home.user-type'),
      dataIndex: 'profileType',
      key: 'profileType',
      render: (val: string) => {
        if (val === 'BUSINESS_BUYER') return t('home.businessBuyer');
        if (val === 'INDIVIDUAL_BUYER') return t('home.individualBuyer');
        if (val === 'BUSINESS_SELLER') return t('home.businessSeller');
        return val;
      },
    },
    {
      title: t('home.vat-amount'),
      dataIndex: 'vatPercentage',
      key: 'vatPercentage',
      render: (val: number) => (val != null ? `${val}%` : '-'),
    },
    {
      title: t('home.changed-by'),
      dataIndex: 'editBy',
      key: 'editBy',
      render: (val: string) => val || '-',
    },
    {
      title: t('home.date-applied'),
      dataIndex: 'editDate',
      key: 'editDate',
      render: (val: string) => (val ? dayjs(val).format('DD MMM YYYY') : '-'),
    },
    {
      title: t('home.actions'),
      key: 'actions',
      render: (_, record: VatRecord) => (
        <div
          className="w-8 h-8 rounded-md bg-blue-50 flex items-center justify-center cursor-pointer transition-colors hover:bg-blue-100"
          onClick={() => onEdit(record)}
        >
          <Edit2 size={16} className="text-blue-500" variant="Bold" />
        </div>
      ),
    },
  ];

  return (
    <div className="bg-white rounded-xl p-6 flex flex-col gap-6 shadow-sm border border-gray-100">
      <div className="flex flex-col gap-1">
        <h3 className="text-[#111928] text-2xl font-bold leading-none">
          {t('home.vats-title')}
        </h3>
        <SectionDesc text={t('home.vats-desc')} />
      </div>
      <CustomTable
        columns={vatColumns}
        dataSource={vatsData}
        currentPage={0}
        totalElements={vatsResponse?.data?.totalElements || vatsData.length}
        onPageChange={() => {}}
        onRowClick={() => {}}
        pagination={false}
        loading={isLoading}
      />
    </div>
  );
}
